import { useEffect, useRef } from 'react';
import { ITaskFieldError, TaskErrorField } from '../helpers/taskCreationErrorHelper';

interface UseTaskFieldErrorProps {
  taskFieldError: ITaskFieldError | null;
  clearTaskFieldError: () => void;
  matterId: string | undefined;
}

export const useTaskFieldError = ({
  taskFieldError,
  clearTaskFieldError,
  matterId,
}: UseTaskFieldErrorProps) => {
  const errorFieldRef = useRef<HTMLDivElement>(null);

  // The failure belongs to the matter that was submitted, so picking another one retires it
  useEffect(() => {
    clearTaskFieldError();
  }, [matterId]);

  // The save button sits below the fold, so the failing field is usually off screen
  useEffect(() => {
    if (!taskFieldError) return;
    errorFieldRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, [taskFieldError]);

  return {
    errorFieldRef,
    matterErrorMessage:
      taskFieldError?.field === TaskErrorField.MATTER ? taskFieldError.message : null,
  };
};
